export default function Contact() {
  return <section className="contact" id="contact">
    <div className="contact-card">
      <div>
        <p className="eyebrow">Let’s work together</p>
        <h2>What are you working on?</h2>
        <p>Tell me what you’re building, where you’re stuck, and your ideal timeline. A few sentences are enough to start.</p>
      </div>
      <div className="contact-actions">
        <a className="btn primary" href="mailto:benrstewart.12@gmail.com?subject=Project%20inquiry">Email me about your project <span aria-hidden="true">↗</span>
        </a>
        <a className="email" href="mailto:benrstewart.12@gmail.com">benrstewart.12@gmail.com</a>
      </div>
    </div>
  </section>;
}
